import React from 'react';
import { FieldError } from 'react-hook-form';

interface DynamicFormErrorProps {
  error?: FieldError;
  label: string;
  errorMessage?: string;
}

export default function DynamicFormError({ error, label, errorMessage }: DynamicFormErrorProps) {
  if (!error) return null;

  if (errorMessage) {
    return <div className="dynamic-form-error">{errorMessage}</div>;
  }

  if (error.type === 'required' && error.message === '') {
    return <div className="dynamic-form-error">{`${label} is a required field.`}</div>;
  }

  return <div className="dynamic-form-error">{error.message}</div>;
}
